import React from "react";
import { formatStaffDepartmentLabel } from "../../utils/visitorHelpers";
import "../../styles/visitorWorkspace.css";

/** Directory / view — staff name + Office or Reception badge (same as register banner). */
export default function RegisteredByCell({ row }) {
  const name = String(row?.created_by_name ?? "").trim();
  const dept = formatStaffDepartmentLabel({
    role_slug: row?.created_by_role_slug,
  });

  if (!name && !dept) {
    return <span className="visitor-created-by">—</span>;
  }

  return (
    <span className="visitor-created-by">
      {name ? <span className="visitor-created-by__name">{name}</span> : null}
      {dept ? <span className="visitor-created-by__dept">{dept}</span> : null}
    </span>
  );
}
